// Mock data for Podcast Guest Manager

export const shows = [
  {
    id: 'wine-talks',
    name: 'Wine Talks with Paul K',
    short: 'WT',
    color: '#722F37',
    accent: '#C9A961',
    cover: 'https://images.podpage.com/https%3A%2F%2Fstatic.libsyn.com%2Fp%2Fassets%2F2%2F5%2F1%2Fd%2F251dca564a38a833e55e3c100dce7605%2FWT_cover_art_new4.jpg?auto=format&dpr=1&h=200&w=200&s=7ef46f788b11da4df6d63b650cff9eef',
    description: 'Conversations with winemakers, sommeliers and the people behind the bottle.'
  },
  {
    id: 'song-of-america',
    name: 'The Song of America with Paul K',
    short: 'SOA',
    color: '#1B2D5B',
    accent: '#B83A3A',
    cover: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&q=80',
    description: 'Stories from the heart of American music and culture.'
  }
];

export const tables = [
  { id: 'guests', name: 'Guests', icon: 'Users' },
  { id: 'episodes', name: 'Episodes', icon: 'Mic' },
  { id: 'releases', name: 'Release Forms', icon: 'FileSignature' },
  { id: 'templates', name: 'Email Templates', icon: 'Mail' }
];

export const statusOptions = [
  { value: 'potential', label: 'Potential Guest', color: '#A78BFA' },
  { value: 'invited', label: 'Invited', color: '#94A3B8' },
  { value: 'confirmed', label: 'Confirmed', color: '#3B82F6' },
  { value: 'recorded', label: 'Recorded', color: '#8B5CF6' },
  { value: 'edited', label: 'In Editing', color: '#F59E0B' },
  { value: 'published', label: 'Published', color: '#10B981' }
];

export const releaseStatusOptions = [
  { value: 'pending', label: 'Pending', color: '#94A3B8' },
  { value: 'sent', label: 'Sent', color: '#3B82F6' },
  { value: 'reminded', label: 'Reminded', color: '#F59E0B' },
  { value: 'signed', label: 'Signed', color: '#10B981' }
];

export const mockGuests = [
  {
    id: 'g1',
    showId: 'wine-talks',
    name: 'Mallory Tsipouria',
    email: 'mallory@georgianwines.com',
    company: 'Georgian Wines USA',
    role: 'Importer',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop',
    episodeTitle: 'Bringing Georgia to Your Glass',
    episodeDate: '2026-05-04',
    recordingDate: '2026-04-28',
    status: 'published',
    releaseStatus: 'signed',
    signedDate: '2026-04-29',
    interestedParties: ['producer@winetalks.com', 'editor@winetalks.com'],
    platforms: {
      apple: 'https://podcasts.apple.com/us/podcast/id1462215436',
      spotify: 'https://open.spotify.com/show/wt',
      youtube: 'https://youtube.com/watch?v=abc123',
      libsyn: 'https://winetalks.libsyn.com/georgia'
    },
    thumbnail: 'https://static.libsyn.com/p/assets/c/0/9/6/c096d10181fa49abd959afa2a1bf1c87/mt.png',
    thumbnail16x9: 'https://images.unsplash.com/photo-1474722883778-792e7990302f?w=800&h=450&fit=crop',
    notes: 'Great storyteller. Bring back for follow-up on ancient varietals.',
    socials: { linkedin: 'mallory-t', instagram: '@georgian_wines', twitter: '' },
    tags: ['Importer', 'Georgia', 'Ancient Wines']
  },
  {
    id: 'g2',
    showId: 'wine-talks',
    name: 'Jane Anson',
    email: 'jane@janeanson.com',
    company: 'Inside Bordeaux',
    role: 'Author & Historian',
    avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop',
    episodeTitle: 'Beyond Luxury: Bordeaux\'s True Essence',
    episodeDate: '2026-05-26',
    recordingDate: '2026-05-12',
    status: 'published',
    releaseStatus: 'signed',
    signedDate: '2026-05-13',
    interestedParties: ['producer@winetalks.com'],
    platforms: {
      apple: 'https://podcasts.apple.com/us/podcast/id1462215436',
      spotify: 'https://open.spotify.com/show/wt',
      youtube: 'https://youtube.com/watch?v=def456',
      libsyn: 'https://winetalks.libsyn.com/bordeaux'
    },
    thumbnail: 'https://static.libsyn.com/p/assets/3/7/3/6/37365533fe3c947cd959afa2a1bf1c87/ja.png',
    thumbnail16x9: 'https://images.unsplash.com/photo-1547595628-c61a29f496f0?w=800&h=450&fit=crop',
    notes: 'Quintessential Bordeaux expert. Scheduling was complex.',
    socials: { linkedin: 'jane-anson', instagram: '@janeanson', twitter: '@newbordeaux' },
    tags: ['Author', 'Bordeaux']
  },
  {
    id: 'g3',
    showId: 'wine-talks',
    name: 'Dr. Peter Klosse',
    email: 'peter@klosse.nl',
    company: 'Academy of Gastronomy',
    role: 'Neuroscientist',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop',
    episodeTitle: 'The Neuroscience of Taste and Harmony',
    episodeDate: '2026-05-21',
    recordingDate: '2026-05-08',
    status: 'published',
    releaseStatus: 'signed',
    signedDate: '2026-05-09',
    interestedParties: [],
    platforms: {
      apple: 'https://podcasts.apple.com/us/podcast/id1462215436',
      spotify: '',
      youtube: 'https://youtube.com/watch?v=ghi789',
      libsyn: 'https://winetalks.libsyn.com/klosse'
    },
    thumbnail: 'https://static.libsyn.com/p/assets/1/f/a/b/1fab3c8b24049c8816c3140a3186d450/nm-20260521-dlmk6glejr.png',
    thumbnail16x9: '',
    notes: 'Deep technical conversation. May need shorter follow-up.',
    socials: { linkedin: 'peter-klosse', instagram: '', twitter: '' },
    tags: ['Science', 'Food Pairing']
  },
  {
    id: 'g4',
    showId: 'wine-talks',
    name: 'Natalie McLean',
    email: 'natalie@nataliemaclean.com',
    company: 'NatalieMacLean.com',
    role: 'Wine Critic',
    avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&h=200&fit=crop',
    episodeTitle: 'Navigating Wine Lists and Confidence',
    episodeDate: '2026-05-19',
    recordingDate: '2026-05-05',
    status: 'edited',
    releaseStatus: 'reminded',
    signedDate: null,
    interestedParties: ['producer@winetalks.com'],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: 'https://static.libsyn.com/p/assets/8/3/c/f/83cf3fa560e4655b16c3140a3186d450/nm.png',
    thumbnail16x9: '',
    notes: 'Awaiting release form signature. Second reminder sent.',
    socials: { linkedin: 'natalie-maclean', instagram: '@nataliemaclean', twitter: '@nataliemaclean' },
    tags: ['Critic', 'Education']
  },
  {
    id: 'g5',
    showId: 'wine-talks',
    name: 'Ivo Assanelli',
    email: 'ivo@caiarosa.it',
    company: 'Caiarosa, Tuscany',
    role: 'Winemaker',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop',
    episodeTitle: 'Behind the Bottle: Tuscan Winemaking',
    episodeDate: '2026-06-12',
    recordingDate: '2026-05-30',
    status: 'recorded',
    releaseStatus: 'sent',
    signedDate: null,
    interestedParties: ['editor@winetalks.com'],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: 'https://static.libsyn.com/p/assets/6/c/5/9/6c5921b1a81bd8d0d959afa2a1bf1c87/iv.png',
    thumbnail16x9: '',
    notes: 'Recording done. Awaiting form.',
    socials: { linkedin: 'ivo-assanelli', instagram: '@caiarosa', twitter: '' },
    tags: ['Winemaker', 'Tuscany']
  },
  {
    id: 'g6',
    showId: 'wine-talks',
    name: 'Klaus de Jong',
    email: 'klaus@dejongfilms.com',
    company: 'De Jong Films',
    role: 'Cinematographer',
    avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop',
    episodeTitle: 'Behind the Lens: Wine Culture on Film',
    episodeDate: '2026-06-20',
    recordingDate: null,
    status: 'confirmed',
    releaseStatus: 'pending',
    signedDate: null,
    interestedParties: [],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: 'https://static.libsyn.com/p/assets/3/b/f/e/3bfeb022344a2b03d959afa2a1bf1c87/kdj.png',
    thumbnail16x9: '',
    notes: 'Send invite + release form together.',
    socials: { linkedin: 'klaus-de-jong', instagram: '@klausdejong', twitter: '' },
    tags: ['Filmmaker', 'Storytelling']
  },
  {
    id: 'g7',
    showId: 'wine-talks',
    name: 'Sarah Mitchell',
    email: 'sarah@sonomawines.com',
    company: 'Sonoma Family Vineyards',
    role: 'Owner',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=200&fit=crop',
    episodeTitle: 'Family Legacy in Sonoma',
    episodeDate: '2026-07-08',
    recordingDate: null,
    status: 'invited',
    releaseStatus: 'pending',
    signedDate: null,
    interestedParties: [],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: '',
    thumbnail16x9: '',
    notes: '',
    socials: { linkedin: '', instagram: '@sonomafamilywines', twitter: '' },
    tags: ['Owner', 'Sonoma']
  },
  {
    id: 'g8',
    showId: 'song-of-america',
    name: 'Marcus Holloway',
    email: 'marcus@bluesarchive.org',
    company: 'Delta Blues Archive',
    role: 'Music Historian',
    avatar: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=200&h=200&fit=crop',
    episodeTitle: 'The Roots of the Delta Sound',
    episodeDate: '2026-05-15',
    recordingDate: '2026-05-01',
    status: 'published',
    releaseStatus: 'signed',
    signedDate: '2026-05-02',
    interestedParties: ['producer@songofamerica.com'],
    platforms: {
      apple: 'https://podcasts.apple.com/us/podcast/song-of-america',
      spotify: 'https://open.spotify.com/show/soa',
      youtube: 'https://youtube.com/watch?v=soa1',
      libsyn: ''
    },
    thumbnail: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=400&fit=crop',
    thumbnail16x9: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?w=800&h=450&fit=crop',
    notes: 'Incredible archive access. Schedule a part two.',
    socials: { linkedin: 'marcus-holloway', instagram: '@deltablues', twitter: '@bluesarchive' },
    tags: ['Blues', 'History']
  },
  {
    id: 'g9',
    showId: 'song-of-america',
    name: 'Elena Rodriguez',
    email: 'elena@tejanorecords.com',
    company: 'Tejano Records',
    role: 'Producer',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop',
    episodeTitle: 'Tejano: The Sound of the Border',
    episodeDate: '2026-06-02',
    recordingDate: '2026-05-20',
    status: 'edited',
    releaseStatus: 'reminded',
    signedDate: null,
    interestedParties: ['editor@songofamerica.com'],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&h=400&fit=crop',
    thumbnail16x9: '',
    notes: 'Awaiting release. Reminder sent twice.',
    socials: { linkedin: 'elena-rodriguez', instagram: '@tejanorecords', twitter: '' },
    tags: ['Tejano', 'Producer']
  },
  {
    id: 'g10',
    showId: 'song-of-america',
    name: 'James Whitfield',
    email: 'james@bluegrasshall.org',
    company: 'Bluegrass Hall of Fame',
    role: 'Curator',
    avatar: 'https://images.unsplash.com/photo-1542178243-bc20204b769f?w=200&h=200&fit=crop',
    episodeTitle: 'Bluegrass and the American Spirit',
    episodeDate: '2026-06-18',
    recordingDate: null,
    status: 'confirmed',
    releaseStatus: 'sent',
    signedDate: null,
    interestedParties: [],
    platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
    thumbnail: '',
    thumbnail16x9: '',
    notes: '',
    socials: { linkedin: 'james-whitfield', instagram: '', twitter: '' },
    tags: ['Bluegrass']
  }
];

export const emailTemplates = [
  {
    id: 't1',
    name: 'Initial Release Request',
    subject: 'Talent Release Form for {{episode}}',
    body: 'Hi {{firstName}},\n\nThank you again for joining me on {{showName}}! Before we publish your episode, please complete the talent release form at the link below:\n\n{{releaseLink}}\n\nSubmission of this form constitutes acceptance of the terms and release.\n\nLooking forward,\nPaul K'
  },
  {
    id: 't2',
    name: 'Friendly Reminder',
    subject: 'Quick reminder: Release form for {{episode}}',
    body: 'Hi {{firstName}},\n\nJust a friendly nudge — we still need your talent release before publishing. It only takes a minute:\n\n{{releaseLink}}\n\nThanks so much!\nPaul'
  },
  {
    id: 't3',
    name: 'Second Reminder',
    subject: 'We need your release to publish {{episode}}',
    body: 'Hi {{firstName}},\n\nYour episode is ready to go live, but we are waiting on your release form. Please take a moment to sign:\n\n{{releaseLink}}\n\nIf you have any questions or concerns, just reply to this email.\n\nBest,\nPaul'
  },
  {
    id: 't4',
    name: 'Show Assets Delivery',
    subject: 'Your episode is live — share away!',
    body: 'Hi {{firstName}},\n\nYour episode "{{episode}}" is now live! Here are your show assets:\n\n• Apple Podcasts: {{appleLink}}\n• Spotify: {{spotifyLink}}\n• YouTube: {{youtubeLink}}\n• Square thumbnail: attached\n• 16:9 thumbnail (YouTube): attached\n\nWe would love for you to share with your network. Thank you again for the great conversation!\n\nCheers,\nPaul'
  }
];

export const calendlyFeed = [
  { id: 'c1', name: 'Sarah Mitchell', email: 'sarah@sonomawines.com', date: '2026-07-08', received: '2026-06-20', imported: true },
  { id: 'c2', name: 'Tom Bridges', email: 'tom@napavalley.com', date: '2026-07-15', received: '2026-06-22', imported: false },
  { id: 'c3', name: 'Ana Costa', email: 'ana@portuguesewine.pt', date: '2026-07-22', received: '2026-06-23', imported: false }
];
